import React from "react";
import { RichText } from "prismic-reactjs";

export default class Trustee extends React.Component {
  renderList() {
    const { data, prismicCtx } = this.props;

    return (
      <div className="row trustee-items">
        {data.items.map((item, index) => {
          return (
            <div className="col-12 col-md-6" key={index}>
              <h3 className="text-white">
                {RichText.asText(item.person_name)}
              </h3>
              {item.person_position.text ? (
                <span>{RichText.asText(item.person_position)}</span>
              ) : null}
              <div className="trustee-item-text">
                {RichText.render(
                  item.person_description,
                  prismicCtx.linkResolver
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="text-white">
            {RichText.asText(this.props.data.primary.people_title)}
          </h2>

          {this.props.data.items.length > 0 ? this.renderList() : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/slices/Trustee.js